import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#conforming-limits-tool-app', App);
